import React from 'react';
import SvgIcon48 from '../svgIcon48';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const PinIcon = ({ ...others }) => (
  <SvgIcon48
    title="icons / nav / pin"
    {...others}
  >
    <path d="M15.8882323,29.1113289 L6.06823558,19.5237862 L7.22255823,18.5038708 C10.8396667,15.3079321 15.7459514,14.0382052 20.4290757,15.0406571 L30.5406573,2.51065591 L45,16.7546949 L32.203232,26.7210252 C33.2200102,31.3123582 32.0556511,36.1400305 29.0115053,39.7726265 L28.0199428,40.9558636 L18.2056945,31.3739333 L5.3464996,44.0998723 L3,44.0998723 L3,41.8582975 L15.8882323,29.1113289 Z M30.783317,6.7665778 L21.4918544,18.2803095 L20.5837791,18.0252028 C17.0659098,17.0369231 13.3194959,17.6701497 10.3416653,19.6967765 L27.7396687,36.6829431 C29.6559692,33.7036258 30.2129877,30.0160689 29.2115996,26.5661157 L28.9411878,25.634501 L40.6665229,16.50262 L30.783317,6.7665778 Z" id="Combined-Shape"></path>
  </SvgIcon48>
);

export default PinIcon;
